import Controler from '../base/Controler';
import MasonryGrid from './MasonryGrid';

const imagesLoaded = require('imagesloaded');

class GalleryLayoutControler extends Controler {
  constructor() {
    super();

    this.init();
  }

  init(): void {
    this.selectElements('.js-masonry-layout').forEach(el => {
      imagesLoaded(el, () => {
        const grid = new MasonryGrid(el);
        setTimeout(() => {
          el.classList.remove('isHidden');
        }, 0);
      });
    });
  }
}

export default GalleryLayoutControler;
